import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Table,
  Typography,
  Switch,
  Space,
  Select,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import React, { Fragment, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  addSinglePublicHoliday,
  loadAllPublicHoliday,
} from "../../redux/rtk/features/publicHoliday/publicHolidaySlice";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { getAllMaster } from "../../redux/rtk/features/masters/masterSlice";
import { CompanyDetailsGetbyId } from "../../redux/rtk/features/settingSlice/settingSlice";

// Extend dayjs with plugins
dayjs.extend(utc);
dayjs.extend(timezone);

function CustomTable({
  list,
  loading,
  onEdit,
  financialYears,
  selectedYear,
  onYearChange,
}) {
  const [columnsToShow, setColumnsToShow] = useState([]);
  const { Option } = Select;
  const masterData = useSelector((state) => state.masters.masters);
  const companyDetail = useSelector((state) => state?.setting?.list) || [];
  // console.log("companyDetail", companyDetail);
  const columns = [
    {
      id: 1,
      title: "S.No",
      dataIndex: "serial",
      key: "serial",
    },
    {
      id: 2,
      title: "Holiday Name",
      dataIndex: "HolidayName",
      key: "HolidayName",
    },
    {
      id: 3,
      title: "Start Date",
      dataIndex: "StartDate",
      key: "StartDate",
      render: (date) => dayjs(date).format("YYYY-MM-DD"),
    },
    {
      id: 4,
      title: "End Date",
      dataIndex: "EndDate",
      key: "EndDate",
      render: (date) => dayjs(date).format("YYYY-MM-DD"),
    },
    {
      id: 5,
      title: "Occasion",
      dataIndex: "Reason",
      key: "Reason",
    },
    {
      id: 6,
      title: "National",
      dataIndex: "IsNational",
      key: "IsNational",
      render: (value) => (value ? "Yes" : "No"),
    },
    {
      id: 7,
      title: "Restricted",
      dataIndex: "IsRestricted",
      key: "IsRestricted",
      render: (value) => (value ? "Yes" : "No"),
    },
    {
      id: 9,
      title: "Action",
      dataIndex: "HolidayId",
      key: "action",
      render: (id, record) => (
        <Space>
          {/* <UserPrivateComponent permission={"readSingle-publicHoliday"}> */}
          {/* <ViewBtn path={`/admin/holiday/public/${id}/`} /> */}
          {/* </UserPrivateComponent> */}
          {/* <UserPrivateComponent permission={"update-publicHoliday"}> */}
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => onEdit(record)}
          />
          {/* </UserPrivateComponent> */}
        </Space>
      ),
    },
  ];

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  const addKeys = (arr) =>
    arr.map((i, index) => ({ ...i, key: i.HolidayId, serial: index + 1 }));

  return (
    <>
      <div className="flex my-2 justify-between">
        <div className="w-50">
          <h4 className="text-xl mb-2">Public Holiday List</h4>
        </div>
        <div className="flex items-center">
          <Select
            style={{ width: 180, marginRight: 10 }}
            placeholder={
              companyDetail?.IsLeaveCalenderYear
                ? "Select Year"
                : "Select Financial Year"
            }
            value={selectedYear}
            onChange={onYearChange}
          >
            {companyDetail?.IsLeaveCalenderYear ? (
              masterData?.CalendarYearDetails.map((year) => (
                <Option key={year.YearId} value={year.YearId}>
                  {year.YearName}
                </Option>
              ))
            ) : (
              financialYears.map((year) => (
                <Option key={year.YearId} value={year.YearId}>
                  {year.YearName}
                </Option>
              ))
            )}
          </Select>

          {list && (
            <div style={{ width: 300, marginLeft: "10px" }}>
              <CsvLinkBtn>
                <CSVLink
                  data={list}
                  className="btn btn-dark btn-sm mb-1"
                  filename="public-holiday"
                >
                  Download CSV
                </CSVLink>
              </CsvLinkBtn>
            </div>
          )}
        </div>
      </div>

      {list && (
        <div
          className="public-holiday-table-actions"
          style={{
            marginBottom: "30px",
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
          }}
        >
          <ColVisibilityDropdown
            options={columns}
            columns={columns}
            columnsToShowHandler={columnsToShowHandler}
          />
        </div>
      )}

      {loading ? (
        <div className="text-center py-8">
          <div className="ant-spin ant-spin-lg ant-spin-spinning">
            <span className="ant-spin-dot ant-spin-dot-spin">
              <i className="ant-spin-dot-item"></i>
              <i className="ant-spin-dot-item"></i>
              <i className="ant-spin-dot-item"></i>
              <i className="ant-spin-dot-item"></i>
            </span>
          </div>
          <p className="mt-4 text-gray-600">Loading holidays...</p>
        </div>
      ) : !list || list.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-600">No holidays found.</p>
        </div>
      ) : (
        <Table
          scroll={{ x: true, y: "100%" }}
          pagination={{
            defaultPageSize: 20,
          }}
          columns={columnsToShow}
          dataSource={list ? addKeys(list) : []}
          className="public-holiday-table"
        />
      )}
    </>
  );
}

const AddPublicHoliday = ({ drawer }) => {
  const { list, loading } = useSelector((state) => state.publicHoliday);
  const [loader, setLoader] = useState(false);
  const [form] = Form.useForm();
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentHolidayId, setCurrentHolidayId] = useState(0);
  const dispatch = useDispatch();
  const masterData = useSelector((state) => state.masters.masters);

  const [financialYears, setFinancialYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const { Option } = Select;
  const companyDetail = useSelector((state) => state?.setting?.list) || [];
  // console.log("companyDetail", companyDetail);

  useEffect(() => {
    dispatch(getAllMaster());
    dispatch(CompanyDetailsGetbyId());
  }, [dispatch]);

  // useEffect(() => {
  //   if (masterData && masterData.FinancialYearDetails) {
  //     setFinancialYears(masterData.FinancialYearDetails);

  //     // Auto-select the current financial year
  //     const currentYear = findCurrentFinancialYear(masterData.FinancialYearDetails);
  //     if (currentYear) {
  //       setSelectedYear(currentYear.YearId);
  //       // Set the financialYearId field value to the matching year
  //       form.setFieldsValue({
  //         financialYearId: currentYear.YearId
  //       });
  //     }
  //   }
  // }, [masterData, form]);

  useEffect(() => {
    if (masterData && masterData.FinancialYearDetails) {
      setFinancialYears(masterData.FinancialYearDetails);

      let defaultYear;
      if (companyDetail?.IsLeaveCalenderYear) {
        defaultYear = masterData?.CalendarYearDetails.find(
          (year) => year.IsCurrent
        )?.YearId;
        // console.log("currentdefaultYear", defaultYear);
        
      } else {
        // Find year with IsCurrent true
        defaultYear = masterData.FinancialYearDetails.find(
          (year) => year.IsCurrent
        )?.YearId;
        // console.log("finadefaultYear", defaultYear);

      }

      if (defaultYear) {
        setSelectedYear(defaultYear);
        form.setFieldsValue({
          financialYearId: defaultYear,
        });
      }
    }
  }, [masterData, form, companyDetail]);
  // Load holidays when selected year changes
  useEffect(() => {
    if (selectedYear) {
      dispatch(loadAllPublicHoliday(selectedYear));
    }
  }, [selectedYear, dispatch]);

  // Function to find the current financial year based on current date
  const findCurrentFinancialYear = (years) => {
    if (!years || years.length === 0) return null;

    const currentDate = new Date();

    // Find the financial year where current date falls between StartDate and EndDate
    return years.find((year) => {
      const startDate = new Date(year.StartDate);
      const endDate = new Date(year.EndDate);
      return currentDate >= startDate && currentDate <= endDate;
    });
  };

  const { Title } = Typography;

  const handleYearChange = (yearId) => {
    setSelectedYear(yearId);
    dispatch(loadAllPublicHoliday(yearId));
  };

  const handleEdit = (record) => {
    setIsEditMode(true);
    setCurrentHolidayId(record.HolidayId);
    form.setFieldsValue({
      name: record.HolidayName,
      startDate: record.StartDate ? dayjs(record.StartDate) : null,
      endDate: record.EndDate ? dayjs(record.EndDate) : null,
      Reason: record.Reason,
      isNational: record.IsNational,
      isRestricted: record.IsRestricted,
      financialYearId: record.FinancialYearId || selectedYear,
    });
  };

  const resetForm = () => {
    form.resetFields();
    // Re-select the current financial year when form is reset
    if (selectedYear) {
      form.setFieldsValue({
        financialYearId: selectedYear,
      });
    }
    setIsEditMode(false);
    setCurrentHolidayId(0);
  };

  const onFinish = async (values) => {
    const leaveStartMonthId =
      masterData?.CompanyDetails?.[0]?.LeaveStartMonthId || 1;

    const currentYear = new Date().getFullYear();
    const isCurrentYear = leaveStartMonthId === 1;
    const payload = {
      HolidayId: currentHolidayId,
      HolidayName: values.name,
      StartDate: dayjs(values.startDate).utc(true).format(),
      EndDate: values.endDate ? dayjs(values.endDate).utc(true).format() : null,
      Reason: values.Reason,
      IsNational: values.isNational || false,
      IsRestricted: values.isRestricted || false,
      FinancialYearId: isCurrentYear
        ? 0
        : values.financialYearId || selectedYear,
      CalendarYear: isCurrentYear ? currentYear : 0,
      DataStatus: 1,
    };

    setLoader(true);
    const resp = await dispatch(addSinglePublicHoliday(payload));

    if (resp.payload.message === "success") {
      setLoader(false);
      resetForm();
      dispatch(loadAllPublicHoliday(selectedYear));
      toast.success(
        isEditMode
          ? "Holiday updated successfully"
          : "Holiday added successfully"
      );
    } else {
      setLoader(false);
      toast.error(
        isEditMode ? "Failed to update holiday" : "Failed to add holiday"
      );
    }
  };

  const onFinishFailed = () => {
    toast.warning("Please fill all required fields correctly");
    setLoader(false);
  };

  return (
    <Fragment bordered={false}>
      {/* <UserPrivateComponent permission={"create-publicHoliday"}> */}
      <Row className="add-public-holiday-row" gutter={[16, 16]} justify="space-between">
        {/* Form Column */}
        <Col
          xs={24}
          sm={24}
          md={6}
          lg={6}
          xl={6}
          className="add-public-holiday-form-col column-design border rounded card-custom"
        >
          <Title level={4} className="m-2 mt-5 mb-5 text-center">
            {isEditMode ? "Edit Public Holiday" : "Add Public Holiday"}
          </Title>
          <Form
            style={{ marginBottom: "40px" }}
            form={form}
            name="basic"
            labelCol={{ span: 10 }}
            wrapperCol={{ span: 14 }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            initialValues={{
              isNational: true,
              isRestricted: false,
            }}
          >
            {/* <Form.Item
              name="financialYearId"
              label="Financial Year"
              rules={[
                { required: true, message: "Please select a financial year!" },
              ]}
            >
              <Select placeholder="Select financial year">
                {financialYears.map((year) => (
                  <Option key={year.YearId} value={year.YearId}>
                    {year.YearName}
                  </Option>
                ))}
              </Select>
            </Form.Item> */}

            <Form.Item
              label="Holiday Name"
              name="name"
              rules={[
                { required: true, message: "Please input holiday name!" },
              ]}
            >
              <Input placeholder="e.g., Republic Day" />
            </Form.Item>

            <Form.Item
              label="Start Date"
              name="startDate"
              rules={[{ required: true, message: "Please select start date!" }]}
            >
              <DatePicker
                placeholder="Select Start Date"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item label="End Date" name="endDate">
              <DatePicker
                placeholder="Select End Date"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              label="Occasion"
              name="Reason"
              // rules={[{ required: true, message: "Please input reason!" }]}
            >
              <Input placeholder="e.g., Republic Day" />
            </Form.Item>

            <Form.Item
              label="Is National"
              name="isNational"
              valuePropName="checked"
            >
              <Switch
                onChange={(checked) => {
                  form.setFieldsValue({
                    isNational: checked,
                    isRestricted: !checked,
                  });
                }}
              />
            </Form.Item>

            <Form.Item
              label="Is Restricted"
              name="isRestricted"
              valuePropName="checked"
            >
              <Switch
                onChange={(checked) => {
                  form.setFieldsValue({
                    isRestricted: checked,
                    isNational: !checked,
                  });
                }}
              />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 6, span: 12 }}>
              <Space>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  block
                  loading={loader}
                >
                  {isEditMode ? "Update Public Holiday" : "Add Public Holiday"}
                </Button>
                {isEditMode && (
                  <Button size="large" onClick={resetForm}>
                    Cancel
                  </Button>
                )}
              </Space>
            </Form.Item>
          </Form>
        </Col>

        {/* Table Column */}
        <Col xs={24} sm={24} md={18} lg={18} xl={18} className="add-public-holiday-table-col">
          {/* <UserPrivateComponent permission={"readAll-publicHoliday"}> */}
          <div className="ant-card p-4 rounded public-holiday-table-container">
            <CustomTable
              list={list}
              loading={loading}
              onEdit={handleEdit}
              financialYears={financialYears}
              selectedYear={selectedYear}
              onYearChange={handleYearChange}
            />
          </div>
          {/* </UserPrivateComponent> */}
        </Col>
      </Row>
      {/* </UserPrivateComponent> */}
    </Fragment>
  );
};

export default AddPublicHoliday;
